import CTA10 from './CTA10'
export default CTA10
